import { render, staticRenderFns } from "./veStuLiteraryProgram.vue?vue&type=template&id=d24f235c&scoped=true"
import script from "./veStuLiteraryProgram.vue?vue&type=script&lang=js"
export * from "./veStuLiteraryProgram.vue?vue&type=script&lang=js"
import style0 from "./veStuLiteraryProgram.vue?vue&type=style&index=0&id=d24f235c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24f235c",
  null
  
)

export default component.exports